// extracted by mini-css-extract-plugin
export default {"alert":"alert--Spqub","root":"root--t1kjf"};